import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import axios from 'axios';
import Toasted from 'vue-toasted';

Vue.use(Toasted);
Vue.use(Vuex);

/* eslint-disable */
const state = {
  stats: {},
  recentSearches: [],
  activeUsername: '',
  apiKey: 'cb3e4a63902d47c69a2f4983c0bd3d9a', // prod: cb3e4a63902d47c69a2f4983c0bd3d9a
};

const mutations = {
  initializeStore(state) {
    if (localStorage.getItem('store')) {
      console.log('Localstorage data tapped.');
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem('store'))),
      );
    }
  },
  SET_USER_STATS(state, payload) {
    state.stats = payload.stats;
  },
  SET_ACTIVE_USER(state, name) {
    state.activeUsername = name;
  },
  SET_RECENT_SEARCHES(state, searches) {
    state.recentSearches = searches;
  }
};

const actions = {
  async loadUserStats({ commit }, payload) {
    console.log(`%cLoading stats for user #${payload.user}.`, 'color: yellow');
    try {
      const { data } = await axios.get(`https://www.bungie.net/Platform/Destiny2/${payload.platform}/Account/${payload.user}/Character/0/Stats/?groups=0,0&modes=63&periodType=0`, {
        headers: { 'X-API-KEY': state.apiKey }
      });
      console.log('%cDone.', 'color: green');
      commit('SET_USER_STATS', { user: payload.user, stats: data.Response.pvecomp_gambit.allTime }); 
    } catch (error) {
      console.log(`%cError loading user #${payload.user}.`, 'color: red');
    }
  },
  async loadUserName({ commit }, payload) {
    console.log(`%cLoading stats for user #${payload.user}.`, 'color: yellow');
    try {
      const { data } = await axios.get(`https://www.bungie.net/Platform/User/GetMembershipsById/${payload.user}/${payload.platform}/`, {
        headers: { 'X-API-KEY': state.apiKey }
      });
      console.log('%cDone.', 'color: green');
      commit('SET_ACTIVE_USER', data.Response.destinyMemberships[0].displayName); 
    } catch (error) {
      console.log(`%cError loading user #${payload.user}.`, 'color: red');
    }
  },
};

const getters = {
  stats: state => state.stats,
  users: state => state.users,
  activeUsername: state => state.activeUsername,
  recentSearches: state => state.recentSearches,
};

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
});

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexLocalStorage.plugin],
});

export default store;

// eslint-disable-next-line
store.subscribe((mutation, state) => {
  // eslint-disable-next-line
  localStorage.setItem('store', JSON.stringify(state));
});



// WEBPACK FOOTER //
// ./src/store/index.js